import { render, staticRenderFns } from "./policy-yuri-accordion.vue?vue&type=template&id=1c3dd596&scoped=true&"
import script from "./policy-yuri-accordion.vue?vue&type=script&lang=js&"
export * from "./policy-yuri-accordion.vue?vue&type=script&lang=js&"
import style0 from "./policy-yuri-accordion.vue?vue&type=style&index=0&id=1c3dd596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dd596",
  null
  
)

export default component.exports